<div class="container">
  <img
    class="message-video"
    src="assets/images/telegram/preview-video.webp"
    alt=""
  />
  <button
    mat-mini-fab
    class="open-video"
    (click)="handleOpenVideo()"
  >
    <mat-icon>play_circle</mat-icon>
  </button>
</div>
